function disableScrolling() {
  console.log('disable');
  if ($(document).height() > $(window).height()) {
    const scrollTop = $('html').scrollTop()
      ? $('html').scrollTop()
      : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
    $('html').addClass('disable-scrolling').css('top', -scrollTop);
  }
}

function enableScrolling() {
  const scrollTop = parseInt($('html').css('top'), 10);
  $('html').removeClass('disable-scrolling');
  $('html,body').scrollTop(-scrollTop);
}


function initHeader(){
  const $li = $('.lm-menu__nav-item');
  const $desktop = $('.lm-menu');
  const $mobile = $('.lm-menu-mobile')
  const $hamburger = $('.lm-menu-mobile__hamburger');
  const $mobileSlider = $('.lm-menu-mobile__slider');
  const $mobileOverlay = $('.lm-menu-mobile-overlay');
  const $mobileSubMenu = $('.lm-menu-mobile__nav-item--drop-down')
  let $mobileOpen = false

  $mobileSubMenu.click(function(){
    $($mobileSubMenu).children().removeClass('active');
    $(this).children().addClass('active') 
  })
  


  if ($(window).width() < 1020) {
    $mobile.css( "display", "flex");
    $desktop.hide();
    $hamburger.click(function(){
      if ($mobileOpen == false) {
        $mobileSlider.addClass('active');
        $mobileOverlay.show();
        $mobileOpen = true;
        $hamburger.addClass('open')
        disableScrolling();
        
      }
      else{
        $mobileSlider.removeClass('active');
        $hamburger.removeClass('open')
        $mobileOverlay.hide();
        enableScrolling();
        $mobileOpen = false;
      }
      

    })


  }

  if ($(window).width() > 1020) {
    console.log('big');
    $desktop.css( "display", "flex");
    $mobile.hide();

    $li.hover(function(){
      $(this).children().addClass('active')  
    });
  
    $li.mouseleave(function(){
        $(this).children().removeClass('active'); 
    });
  }  



  

}

$(window).on('debouncedresize load', function(){
  initHeader();
}

);


function initUnicornSlider(){
  const $slider = $('.margic-unicorn__slider');

  $($slider).slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});

  console.log($slider);
}

function foodServiceCarousel(){
  const carousel = $('.food-service-cusroners__inner')

  $(carousel).slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}



$(window).on('load', () => {
  initUnicornSlider()  
  foodServiceCarousel()
});